// Multivariate Dependencies
import React from 'react';
// Components
import { ThreeBreathingDots } from '../../../atoms/ThreeBreathingDots';
import { Container } from '../../../common/styles/container/styles/Container';
import { InteractableIconContainer } from '../components/InteractableIconContainer';
import { DropdownStates } from '../types/DropdownStates';
import { DropdownTestIds } from '../types/DropdownTestIds';
import { DropdownLabels } from '../types/DropdownLabels';
/**
 * Decides what icon to use for the right adornment (left of the dropdown chevron). This currently swaps between
 * - Searching (3 loader dots)
 * - Item selected (an x icon to clear the selected item)
 * - Item not selected (no icon)
 *
 * @param {DropdownStates} dropdownState
 * @param {string} selectedDropdownOption
 * @return {*}
 */
export var getDropdownSuffixAdornment = function (dropdownState, selectedDropdownOption, themeStyles, clearSelectedValue, getEitherDefaultOrErrorPrimaryColour) {
    switch (dropdownState) {
        case DropdownStates.SEARCHING:
            return (React.createElement(Container, { display: 'flex', alignItems: 'center', margin: 'auto', gridColumn: '3', fontSize: '12px', lineHeight: '12px', height: '12px', width: '20px', "data-testid": DropdownTestIds.LoadingIcon },
                React.createElement(ThreeBreathingDots, null)));
        default:
            return selectedDropdownOption && dropdownState !== DropdownStates.LOCKED ? (React.createElement(InteractableIconContainer, { gridColumn: '3', color: getEitherDefaultOrErrorPrimaryColour(themeStyles.contentAccessory), hoverEffects: {
                    color: themeStyles.contentPrimary,
                    transition: 'color 0.15s ease',
                }, onClick: function () { return clearSelectedValue(); }, icon: 'CircleXmark', ariaLabel: DropdownLabels.CLEAR })) : null;
    }
};
//# sourceMappingURL=getDropdownSuffixAdornment.js.map